export default "__VITE_ASSET__0fdb1f39__"